
/** DO NOT EDIT THIS FILE! */
import { Version } from '@angular/core';
import { Bundle } from './models';

export const VERSION = new Version('1.43.71');

export const BUNDLE: Bundle = {
  date: 1790105094730,
  commitSha: '9cede3b999d809b38057cb432fe7edc0cc07b493',
  version: VERSION,
};
